<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_vii"></a>Contents</h2>
<p class="toc"><a href="#/xhtml/fm03"><em>List of plates and figures</em></a></p>
<p class="toc"><a href="#/xhtml/acknowledgements"><em>Acknowledgements</em></a></p>
<p class="toc"><a href="#/xhtml/intro"><em>Introductory note</em></a></p>
<p class="toc"><a href="#/xhtml/foreword"><em>Foreword</em></a></p>
<p class="toc1 t"><a href="#/xhtml/chapter01"><span class="tc1">  1.</span> What’s in a name? How we tell the story of Scotland’s past</a></p>
<p class="toc1"><span href="#/xhtml/chapter02" title="Link target outside of Sample"><span class="tc1">  2.</span> Lost and found: the rediscovery of Roman Scotland</span></p>
<p class="toc1"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><span class="tc1">  3.</span> Scotland before the Romans</span></p>
<p class="toc1"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><span class="tc1">  4.</span> The gathering storm: a warning from the East</span></p>
<p class="toc1"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><span class="tc1">  5.</span> Tracking the tempest</span></p>
<p class="toc1"><span href="#/xhtml/chapter06" title="Link target outside of Sample"><span class="tc1">  6.</span> Enter Agricola</span></p>
<p class="toc1"><span href="#/xhtml/chapter07" title="Link target outside of Sample"><span class="tc1">  7.</span> Smell the smoke: the post-Agricolan black hole</span></p>
<p class="toc1"><span href="#/xhtml/chapter08" title="Link target outside of Sample"><span class="tc1">  8.</span> Exit the IXth</span></p>
<p class="toc1"><span href="#/xhtml/chapter09" title="Link target outside of Sample"><span class="tc1">  9.</span> The Wall</span></p>
<p class="toc1"><span href="#/xhtml/chapter10" title="Link target outside of Sample"><span class="tc1">10.</span> Burnswark: dark deeds in Dumfriesshire</span></p>
<p class="toc1"><span href="#/xhtml/chapter11" title="Link target outside of Sample"><span class="tc1">11.</span> Hail <em>Imperator</em>: the Antonine invasion</span></p>
<p class="toc1"><span href="#/xhtml/chapter12" title="Link target outside of Sample"><span class="tc1">12.</span> A Wall too far?</span></p>
<p class="toc1"><span href="#/xhtml/chapter13" title="Link target outside of Sample"><span class="tc1">13.</span> Trouble up north: bribery and incursions</span></p>
<p class="toc1"><span href="#/xhtml/chapter14" title="Link target outside of Sample"><span class="tc1">14.</span> The African emperor and his brats</span></p>
<p class="toc1"><span href="#/xhtml/chapter15" title="Link target outside of Sample"><span class="tc1">15.</span> The post-Severan aftermath and the rise of the Picts</span></p>
<p class="toc1"><span href="#/xhtml/chapter16" title="Link target outside of Sample"><span class="tc1">16.</span> The man who changed the world: the coming of Constantine</span></p>
<p class="toc1"><span href="#/xhtml/chapter17" title="Link target outside of Sample"><span class="tc1">17.</span> Stilicho and Traprain Law, the harpooned whale</span></p>
<p class="toc1"><span href="#/xhtml/chapter18" title="Link target outside of Sample"><span class="tc1">18.</span> Entering the darkness</span></p>
<p class="toc1"><span href="#/xhtml/chapter19" title="Link target outside of Sample"><span class="tc1">19.</span> Conclusion: the Eagle and the Bear</span></p>
<p class="toc t"><span href="#/xhtml/bm01" title="Link target outside of Sample"><em>Places to visit</em></span></p>
<p class="toc"><span href="#/xhtml/glo" title="Link target outside of Sample"><em>Glossary</em></span></p>
<p class="toc"><span href="#/xhtml/bm02" title="Link target outside of Sample"><em>Further reading</em></span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample"><em>Index</em></span></p>
<div class="pagebreak">
<div class="nobreak">
<p class="image"><a id="page_viii"></a><img alt="Illustration" src="images/fviii-01.png"/></p>
<p class="cap">Frontispiece. Artist’s impression of the interior of a Caledonian settlement.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1706a826